import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PopoverDirective, PopoverModule } from 'ngx-bootstrap/popover';
import { AvailableBSPositions } from 'ngx-bootstrap/positioning';

@Component({
  selector: 'nk-help-popover',
  imports: [PopoverModule],
  templateUrl: './help-popover.component.html',
  styleUrls: ['./help-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpPopoverComponent {
  public buttonClass = input('btn btn-outline-link btn-popover');
  /**
   * Set this if you are using popoverContainerClass
   */
  public container = input<string | undefined>(undefined);
  public containerClass = input('');
  public placement = input<AvailableBSPositions>('right');
  public popoverTemplate = input(undefined, {
    transform: (popoverTemplate: PopoverDirective['popover']) => {
      if (typeof popoverTemplate === 'string') {
        return this._translateService.instant(popoverTemplate);
      } else {
        return popoverTemplate;
      }
    },
  });
  private _translateService = inject(TranslateService);
}
